<template>
  <v-card class="hide-overflow fill-height" color="white lighten-1" lighten>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs6>
          <h2 style="color: #666">Finalizar Compra</h2>
        </v-flex>
        <v-flex xs6 class="text-right">
          <h2 style="color: brown">{{ nomeSite }}</h2>
        </v-flex>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
        <br />

        <v-flex xs12>
          <v-form ref="formAssinar" v-model="assinarValid" lazy-validation class="mt-4">
            <v-flex offset-md3 md6 offset-xs2 xs8 class="justify-center">
              <v-card>
                <v-card-title style="color: white" class="primary justify-center">Plano Escolhido</v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 class="justify-center">
                        <h3 class="text-center">{{ plano.nome }}</h3>
                      </v-flex>
                      <v-flex xs12 class="text-center">
                        <router-link to="/assine">
                          <a href="#" style="font-size: 10px">Para escolher outro plano, clique aqui</a>
                        </router-link>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>

            <MinhasAssinaturas></MinhasAssinaturas>

            <v-card class="mt-4">
              <v-card-title>
                <strong>Verifique seus produtos</strong>
              </v-card-title>
              <v-card-text>
                <v-divider></v-divider>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex offset-md3 md6 xs12>
                      <v-data-table mobile-breakpoint="0" :headers="headerProdutos" :items="produtos" no-data-text no-results-text hide-default-header hide-default-footer>
                        <template v-slot:item.actions="{ item }">
                          <v-btn fab x-small v-if="!item.obrigatorio" @click="adicionarRemoverProduto(item)" :disabled="isUpdating || idAssinatura != null">
                            <v-icon :color="item.situacao ? 'red' : 'blue'" :title="item.situacao ? 'Remover Produto' : 'Adicionar Produto'">{{
                              item.situacao ? "remove" : "add"
                            }}</v-icon></v-btn
                          >
                        </template>
                        <template v-slot:item.situacao="{ item }">
                          <span :class="item.situacao ? 'blue--text' : 'red--text'">{{ item.situacao ? "INCLUÍDO" : "REMOVIDO" }}</span>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>

            <v-card class="mt-4">
              <v-card-title>
                <strong>Selecione a cobrança</strong>
              </v-card-title>
              <v-card-text>
                <v-divider></v-divider>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-autocomplete
                        :disabled="isUpdating || idAssinatura != null"
                        v-model="formaPagamentoSelecionada"
                        :items="formasPagamento"
                        :filter="filtrarObjetos"
                        hint="Obrigatório"
                        :rules="[validacao.idFormaPgto == false || validacao.idFormaPgto, (value) => value != null || 'Obrigatório']"
                        label="Forma de Pagamento"
                        item-text="nome"
                        item-value="id"
                        autocomplete="disabled"
                        :name="Math.random()"
                        no-data-text
                        @change="validacao.idFormaPgto = false"
                        return-object
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-radio-group v-model="regraAjuste">
                        <template v-slot:label>
                          <span style="font-size: 13px">Parcelamento:</span>
                        </template>
                        <v-row class="justify-center">
                          <v-col v-for="item in parcelamento" :key="item.nro" :item="item" :value="item.nro" cols="12" md="4" xs="12">
                            <v-card class="mx-auto text-center">
                              <v-card-subtitle>
                                <v-radio :value="item.nro" @click="validacao.parcelamento = false" :disabled="isUpdating || idAssinatura != null">
                                  <template v-slot:label>
                                    <div @click="validacao.parcelamento = false" :disabled="isUpdating">
                                      {{ item.nro }} x {{ item.vlrUnit }} = <span class="blue--text"> {{ item.vlrTot }} </span>
                                    </div>
                                  </template>
                                </v-radio>
                              </v-card-subtitle>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12>
                      <v-sheet class="ml-1 blue--text" :value="true" v-if="plano.degustacao"
                        >Você só será cobrado após o término do período de degustação de {{ plano.degustacao }} dias.</v-sheet
                      >
                    </v-flex>
                    <v-flex xs12>
                      <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.parcelamento">{{ validacao.parcelamento }}</v-sheet>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>

            <Endereco
              ref="endereco"
              :endereco.sync="endereco"
              :idAssinatura.sync="idAssinatura"
              :impresso.sync="impresso"
              :validacao.sync="validacao"
              :isUpdating.sync="isUpdating"
              v-if="impresso || !endereco.id"
            ></Endereco>

            <CartaoCredito ref="cartaoCredito" :validacao.sync="validacao" :isUpdating.sync="isUpdating" v-if="formaPagamentoSelecionada.tipo == 'CARTAO_CREDITO'"></CartaoCredito>

            <ContaCorrente ref="contaCorrente" :validacao.sync="validacao" :isUpdating.sync="isUpdating" v-if="formaPagamentoSelecionada.tipo == 'DEBITO_CONTA'"></ContaCorrente>

            <v-flex xs12 class="text-center mt-2" v-if="captcha">
              <p style="color: blue">Marque a caixa para validar seu acesso e clique em [Assinar]</p>
              <div id="g-recaptcha" class="g-recaptcha" data-callback="enableBtn" style="display: inline-block"></div>
            </v-flex>
            <v-flex xs12>
              <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
            </v-flex>
            <v-flex xs12>
              <v-sheet class="ml-1 red--text" :value="true" v-if="mensagemErro">{{ mensagemErro }}</v-sheet>
            </v-flex>
            <v-flex xs12 class="text-center">
              <v-btn :disabled="isUpdating || excesso" :loading="loading" class="primary" large @click="assinar">Assinar</v-btn>
            </v-flex>
          </v-form>
        </v-flex>

        <v-dialog persistent v-model="dialogConfirm" max-width="360">
          <v-card>
            <v-toolbar>
              <span class="headline">Verificação</span>
            </v-toolbar>
            <v-card-text style="font-weight: bold"><br />{{ msgConfirm }}</v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="retornar">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
import { api } from "@/services/api.js";
import util from "../util";
import MinhasAssinaturas from "./Assinaturas.vue";
import Endereco from "../components/Endereco.vue";
import CartaoCredito from "../components/CartaoCredito.vue";
import ContaCorrente from "../components/ContaCorrente.vue";
export default {
  components: { MinhasAssinaturas, Endereco, CartaoCredito, ContaCorrente },
  data() {
    return {
      idAssinatura: null,
      excesso: false,
      assinatura: {},
      endereco: { id: null },
      cartao: {},
      conta: {},

      validacao: {
        idFormaPgto: false,
        parcelamento: false,
        cep: false,
        idUF: false,
        idMunicipio: false,
        idCEP: false,
        bairro: false,
        idTipo: false,
        logradouro: false,
        numero: false,
        complemento: false,
        idModoEntrega: false,
        cartao_numero: false,
        cartao_nome: false,
        cartao_validade: false,
        cartao_cvv: false,
        conta_idBanco: false,
        conta_agencia: false,
        conta_numero: false,
        mensagemErro: false
      },

      headerProdutos: [
        { text: "", value: "nome" },
        { text: "", value: "tipo" },
        { text: "", value: "situacao" },
        { text: "", value: "actions" }
      ],

      assinarValid: true,
      captcha: true,
      sitekey: "",
      nomeSite: "",
      produtos: [],
      impresso: false,
      plano: {},
      formasPagamento: [],
      formaPagamentoSelecionada: {},
      parcelamento: [],
      parcelas: [],
      parcelaSelecionada: { id: null },
      regraAjuste: null,

      mensagemErro: "",
      isUpdating: false,
      loading: false,
      dialogConfirm: false,
      msgConfirm: "",
      prosseguir: false
    };
  },
  methods: {
    async carregarPlano() {
      try {
        const response = await api.get("/ass/paywall/plano/" + this.$route.params.url);
        this.plano = response.data;
        this.formasPagamento = this.plano.formasPagamento;
        this.produtos = this.plano.produtos;
        var item = this.produtos.find((dado) => dado.tipo == "IMPRESSO");
        if (item) {
          this.impresso = true;
        }
        this.produtos.forEach((element) => {
          if (element.tipo == "CLUBE" && element.dependentes && this.$store.state.usuario.cobranca.dependentes) {
            element.nome += ` (dependentes: ${this.$store.state.usuario.cobranca.dependentes})`;
          }
        });

        this.formaPagamentoSelecionada = this.formasPagamento[0];

        if (this.$store.state.usuario.cobranca && !this.$store.state.usuario.cobranca.statusCredito) {
          this.msgConfirm = "Operação não permitida - entre em contato com o jornal";
          this.dialogConfirm = true;
          return;
        }

        if (this.$store.state.site.googleCaptchaSite) {
          this.sitekey = this.$store.state.site.googleCaptchaSite;
          window.grecaptcha.render("g-recaptcha", {
            sitekey: this.sitekey
          });
        } else {
          this.captcha = false;
        }

        this.endereco = this.$store.state.usuario.endereco;
        this.nomeSite = this.$store.state.site.nome;
      } catch (e) {
        console.log(e);
        this.msgConfirm = "Ocorreu um erro ao tentar carregar os dados deste plano - entre em contato com o jornal";
        this.dialogConfirm = true;
      }
    },
    async carregarParcelamento() {
      try {
        this.prosseguir = false;
        var vlrBruto = 0; //* valor de tabela total da renovação (impresso+digital)
        var vlrFixo = 0; //* valor de tabela do clube do assinante
        this.produtos.forEach((element) => {
          if (element.situacao) {
            if (element.tipo == "CLUBE" && element.dependentes) {
              vlrFixo += parseFloat(element.valor) * (this.$store.state.usuario.cobranca.dependentes ? this.$store.state.usuario.cobranca.dependentes + 1 : 1);
            } else {
              vlrBruto += parseFloat(element.valor) * 1; //Paywall só vende 1 edição
            }
          }
        });

        if (util.isFormaPgtoValorZero(this.formaPagamentoSelecionada.tipo)) {
          vlrBruto = 0;
          if (!this.$store.state.usuario.promocional) {
            //* só pode comprar assinatura cortesia pela tag promo=1 - o usuário deverá ter o código promocional - usuário só terá promocional, se este foi validado no login (ou novo cadastro)
            this.msgConfirm = "É necessário informar o código promocional - escolha outro plano ou efetue logoff para acessar com o código promocional.";
            this.dialogConfirm = true;
            return;
          }
        }

        if (!util.isFormaPgtoValorZero(this.formaPagamentoSelecionada.tipo)) {
          if (this.$store.state.usuario.promocional) {
            //* Para evitar problemas, não deixa passar código promocional na compra de plano não promocional
            this.msgConfirm =
              "Você informou um código promocional, mas este plano de assinatura não é promocional - escolha outro plano ou efetue logoff para acessar sem o código promocional.";
            this.dialogConfirm = true;
            return;
          } else if (this.$route.query.promo) {
            //* Como assinante apenas acessou a url do plano não promocional com a query promo=1, deixa realizar a compra normalmente, porém já está avisado que não será promocional
            this.msgConfirm = "Este plano de assinatura não é promocional - escolha outro plano ou efetue logoff para acessar sem o código promocional.";
            this.dialogConfirm = true;
            this.prosseguir = true;
          }
        }

        //* Carrega os itens do parcelamento
        const responseParcelamento = await api.get(
          "/ass/paywall/parcelamento/" +
            this.plano.idPlano +
            "/" +
            this.formaPagamentoSelecionada.id +
            "/" +
            this.formaPagamentoSelecionada.idRegraAjuste +
            "?idSite=" +
            this.$store.state.site.id
        );
        this.parcelamento = [];

        var parcelamentoItens = [];
        var parcItens = [];
        var idRegra = 0;
        for (let index = 0; index < responseParcelamento.data.length; index++) {
          const element = responseParcelamento.data[index];

          var ate = Math.min(this.formaPagamentoSelecionada.maxParcelas, element.ate);
          if (element.id != idRegra) {
            parcItens = [];
          }
          idRegra = element.id;
          //* Se 1 a 10, irá gerar 1 parcelamentoItens para 1-1, 1-2, 1-2-3 até 10 e apresentar: 1x=30,24, 2x=30,24 etc
          for (var x = element.de; x <= ate; x++) {
            var parcTemp = {
              id: element.id,
              nome: x + "x",
              tipo: element.tipo,
              composto: element.composto,
              nivelar: element.nivelar,
              prazoPrimeira: element.prazoPrimeira,
              intervalo: element.intervalo,
              automatica: element.automatica,
              itens: []
            };
            if (element.tipo == "$") {
              parcItens.push({
                numero: x,
                descAcr: element.valor
              });
            } else {
              parcItens = [];
              for (var y = 1; y <= x; y++) {
                parcItens.push({
                  numero: x,
                  descAcr: element.valor
                });
              }
            }
            parcTemp.itens = Object.assign([], parcItens);
            parcelamentoItens.push(parcTemp);
          }
        }

        for (let index = 0; index < parcelamentoItens.length; index++) {
          const regra = parcelamentoItens[index];

          var itensRegra = regra.itens;
          var vlrBase = vlrBruto / itensRegra.length;
          var vlrBaseFixo = vlrFixo / itensRegra.length;
          var vlrAjBase = 0;
          var vlrAjuste = 0;

          var contador = 0;
          regra.itens.forEach((item) => {
            contador++;
            if (regra.tipo == "%") {
              item.valor = vlrBase * (1 + item.descAcr / 100) + vlrBaseFixo;

              vlrAjBase += item.valor;
              if (contador == regra.itens.length) {
                item.valor = vlrAjBase - vlrAjuste;
              }
            } else if (regra.tipo == "$") {
              item.valor = vlrBase + item.descAcr + vlrBaseFixo;
            } else {
              //=
              item.valor = item.descAcr + vlrBaseFixo;
            }
            if (item.valor < 0) {
              item.valor = 0;
            }
            if (regra.composto) {
              vlrBase = item.valor;
            }
            vlrAjuste += parseFloat(item.valor);
            item.valor = item.valor.toFixed(2);
          });
          regra.valor = vlrAjuste;
          regra.valor = parseFloat(regra.valor.toFixed(2));

          regra.nro = util.somenteNumeros(regra.nome);
          regra.vlrUnit = vlrAjuste / regra.nro;
          regra.vlrUnit = regra.vlrUnit.toFixed(2);
          regra.vlrUnit = util.formatCurrency(regra.vlrUnit, "BR", true);
          regra.vlrTot = util.formatCurrency(vlrAjuste.toFixed(2), "BR", true);

          regra.nome = regra.nome + " = " + regra.valor;
          this.parcelamento.push(regra);
        }

        //* Nivela os valores das parcelas, se foi solicitado
        this.parcelamento.forEach((parc) => {
          if (parc.nivelar) {
            var vlrNivelado = parc.valor / parc.itens.length;
            vlrNivelado = vlrNivelado.toFixed(2);
            var somaParc = 0;
            parc.itens.forEach((item) => {
              item.valor = parseFloat(vlrNivelado);
              somaParc += item.valor;
            });
            if (somaParc != parc.valor) {
              //* Ajusta diferença na primeira parcela
              var vlrAjNiv = parc.itens[0].valor + (parc.valor - somaParc);
              vlrAjNiv = vlrAjNiv.toFixed(2);
              parc.itens[0].valor = parseFloat(vlrAjNiv);
            }
          }
        });

        if (this.parcelamento.length == 1) {
          this.regraAjuste = this.parcelamento[0].nro;
        }
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      }
    },

    async criarParcelas() {
      this.parcelas = [];
      if (this.parcelaSelecionada && this.parcelaSelecionada.itens && this.parcelaSelecionada.itens.length > 0) {
        var vlrBruto = 0; //* valor de tabela total da renovação (impresso+digital)
        var vlrFixo = 0; //* valor de tabela do clube do assinante
        this.produtos.forEach((element) => {
          if (element.tipo == "CLUBE" && element.dependentes) {
            vlrFixo += parseFloat(element.valor) * (this.$store.state.usuario.cobranca.dependentes ? this.$store.state.usuario.cobranca.dependentes + 1 : 1);
          } else {
            vlrBruto += parseFloat(element.valor) * 1; //Paywall só vende 1 edição
          }
        });
        var formaPagamento = {
          id: this.formaPagamentoSelecionada.id,
          tipo: this.formaPagamentoSelecionada.tipo,
          maxParcelas: this.parcelaSelecionada.itens[this.parcelaSelecionada.itens.length - 1].numero
        };

        var dadosParcelas = {
          idPlano: this.plano.idPlano,
          idFormaPgto: this.formaPagamentoSelecionada.id,
          idRegraAjuste: this.parcelaSelecionada.idRegraAjuste,
          autorizacao: "",
          diaVencimento: this.$store.state.usuario.cobranca.diaVencimento ? this.$store.state.usuario.cobranca.diaVencimento : 1,
          vlrFixo: vlrFixo,
          vlrBruto: vlrBruto,
          vlrTaxado: 0,
          dtInicio: util.dateToStringUS(new Date()),
          formaPagamento: formaPagamento,
          produtos: this.produtos
        };

        try {
          const retornoParcelas = await api.post("/ass/paywall/parcelas?idSite=" + this.$store.state.site.id, dadosParcelas);
          this.parcelas = retornoParcelas.data;
        } catch (e) {
          this.mensagemErro =
            "ERRO: " +
            (e.toString().includes("status code 400")
              ? "SESSÃO EXPIRADA"
              : e.response && e.response.data && e.response.data.length > 0
              ? e.response.data[0].mensagem
              : "Indeterminado, verifique sua conexão");
          return;
        }
      }
    },

    // async passarCartao() {
    //   this.isUpdating = true;
    //   this.loading = true;
    //   try {
    //     await util.limparObjeto(this.validacao, false);

    //     var novoCartao = this.$refs.cartaoCredito.retornaCartao();

    //     if (!novoCartao.numero || !this.$refs.formAssinar.validate()) {
    //       this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
    //       return;
    //     }

    //     this.cartao = novoCartao;
    //     var body = {
    //       idAssinatura: this.idAssinatura,
    //       cartaoIntegral: this.plano.cartaoIntegral && this.$store.state.usuario.cobranca.cartaoIntegral,
    //       valor: this.parcelaSelecionada.valor,
    //       parcelas: this.parcelas,
    //       cartao: this.cartao
    //     };

    //     //* Envia a assinatura
    //     var response = await api.post("/ass/paywall/cartao", body);

    //     if (response.data.erro) {
    //       //* Se houve erro ao tentar passar o cartão, bloqueia tudo, exceto a aba Cartão para que possa tentar passar novamente - pois a assinatura já está registrada como PROPOSTA
    //       util.validaErros(this.validacao, response.data.erros);
    //       this.$refs.cartaoCredito.validar();
    //       this.idAssinatura = response.data.idAssinatura;
    //       if (response.data.excesso) {
    //         this.excesso = true;
    //       }
    //     } else {
    //       this.$router.push("/assinaturas");
    //     }
    //   } catch (e) {
    //     if (e.toString().includes("status code 400")) {
    //       this.validacao.mensagemErro = "SESSÃO EXPIRADA";
    //     } else if (e.response && e.response.data) {
    //       util.validaErros(this.validacao, e.response.data);
    //       this.$refs.cartaoCredito.validar();
    //     } else {
    //       this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
    //     }
    //   } finally {
    //     this.isUpdating = false;
    //     this.loading = false;
    //   }
    // },

    async assinar() {
      if (this.idAssinatura) {
        //* Se tem idAssinatura, a assinatura já foi salva, porém o cartão não passou - lista suas assinaturas (se houver uma PROPOSTA vai para a tela ATIVAR)
        // await this.passarCartao();
        this.$router.push("/assinaturas");
        this.$router.go("/assinaturas");
        return;
      }

      this.isUpdating = true;
      this.loading = true;
      try {
        await util.limparObjeto(this.validacao, false);

        var erro = false;
        if (!this.parcelaSelecionada.id) {
          this.validacao.parcelamento = "Selecione o parcelamento";
          erro = true;
        }

        if (this.impresso || !this.endereco.id) {
          var novoEndereco = this.$refs.endereco.retornaEndereco();
          if (!novoEndereco.cep) {
            erro = true;
          } else {
            this.endereco = novoEndereco;
            this.endereco.cep = util.somenteNumeros(this.endereco.cep);
          }
        }

        if (this.formaPagamentoSelecionada.tipo == "CARTAO_CREDITO") {
          var novoCartao = this.$refs.cartaoCredito.retornaCartao();
          if (!novoCartao.numero) {
            erro = true;
          } else {
            this.cartao = novoCartao;
          }
        }

        if (this.formaPagamentoSelecionada.tipo == "DEBITO_CONTA") {
          var novaConta = this.$refs.contaCorrente.retornaConta();
          if (!novaConta.numero) {
            erro = true;
          } else {
            this.conta = novaConta;
          }
        }

        if (erro || !this.$refs.formAssinar.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        //* Verifica se esta utilizando captcha
        var resultCaptcha = "";
        if (this.captcha) {
          //* Carrega o resultado
          resultCaptcha = window.grecaptcha.getResponse();

          //* Verifica se o captcha foi validado
          if (!resultCaptcha) {
            document.getElementsByClassName("g-recaptcha")[0].style.border = "2px solid red";
            return;
          } else {
            document.getElementsByClassName("g-recaptcha")[0].style.border = "";
          }
        }

        //* Busca o ip local do usuário
        var ip = { ip: "" };

        try {
          const responseIP = await axios.get("https://ipinfo.io/ip");
          ip = { ip: responseIP.data };
        } catch (e) {
          console.log(e);
        }

        //* Define os dados a serem enviados
        var body = {
          idPlanoPaywall: this.plano.id,
          idPlano: this.plano.idPlano,
          plano: this.plano.nome,
          cartaoIntegral: this.plano.cartaoIntegral && this.$store.state.usuario.cobranca.cartaoIntegral,
          periodo: this.plano.periodo,
          tempo: this.plano.tempo,
          degustacao: this.plano.degustacao,
          captcha: resultCaptcha,
          ip: ip.ip,
          impresso: this.impresso
        };

        body.produtos = [];
        this.produtos.forEach((produto) => {
          if (produto.situacao) {
            body.produtos.push(produto);
          }
        });

        body.parcelas = this.parcelas;
        body.formaPagamento = Object.assign({}, this.formaPagamentoSelecionada);

        body.idRegraAjuste = this.parcelaSelecionada.id;
        body.nroParcelas = this.parcelaSelecionada.nro;
        body.valor = this.parcelaSelecionada.valor;

        if (this.endereco) {
          this.endereco.cobranca = 1;
          this.endereco.entrega = this.impresso;
          body.endereco = this.endereco;
        }
        if (this.cartao.numero) {
          body.cartao = this.cartao;
        }
        if (this.conta.numero) {
          body.conta = this.conta;
        }

        //* Envia a assinatura
        var response = await api.post("/ass/paywall/assinatura", body);

        if (response.data.erro) {
          //* Se houve erro ao tentar passar o cartão, apresenta a mensagem e recarrega a tela de assinaturas (que irá direcionar para a tela ativar), pois já existirá PROPOSTA
          //NÃO:, bloqueia tudo, exceto a aba Cartão para que possa tentar passar novamente - pois a assinatura já está registrada como PROPOSTA
          util.validaErros(this.validacao, response.data.erros);
          try {
            this.$refs.endereco.validar();
            this.$refs.cartaoCredito.validar();
            this.$refs.contaCorrente.validar();
          } catch {}
          this.idAssinatura = response.data.idAssinatura;
          setTimeout(() => {
            this.$router.push("/assinaturas");
            this.$router.go("/assinaturas");
          }, 4000);
        } else {
          this.$router.push("/assinaturas");
          this.$router.go("/assinaturas");
        }
      } catch (e) {
        console.log("e", e);
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
          this.$refs.endereco.validar();
          this.$refs.cartaoCredito.validar();
          this.$refs.contaCorrente.validar();
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
        this.loading = false;
      }
    },

    adicionarRemoverProduto(item) {
      var dadoIndex = this.produtos.indexOf(item);
      var dadoItem = Object.assign({}, item);
      dadoItem.situacao = dadoItem.situacao == 1 ? 0 : 1;
      Object.assign(this.produtos[dadoIndex], dadoItem);

      var item = this.produtos.find((dado) => dado.tipo == "IMPRESSO");
      if (item) {
        this.impresso = true;
      } else {
        //* Pois algum jornal maluco pode deixar impresso como opcional
        this.impresso = false;
      }

      if (this.formaPagamentoSelecionada.id) {
        this.carregarParcelamento();
      }
    },

    retornar() {
      this.dialogConfirm = false;
      if (!this.prosseguir) {
        this.$router.push("/assine");
      }
    },
    filtrarObjetos(item, queryText, itemText) {
      return util.filtrarObjetos(item, queryText, itemText);
    }
  },
  watch: {
    validacao() {},
    endereco() {},
    async formaPagamentoSelecionada(val) {
      if (val) {
        this.regraAjuste = null;
        this.parcelaSelecionada = { id: null };
        this.carregarParcelamento();
      }
    },
    async regraAjuste(val) {
      if (val) {
        this.parcelaSelecionada = this.parcelamento.find((item) => item.nro == val);
        await this.criarParcelas();
      }
    }
  },
  async created() {
    if (!this.$route.params.url) {
      this.$router.push("/assine");
    } else {
      do {
        await util.delay(1000);
      } while (!this.$store.state.site.enderecoSite);

      if (!this.$store.state.login || this.$store.state.usuario.idDependente) {
        if (this.$store.state.site.flip) {
          this.$router.push("/newflip");
        } else {
          this.$router.push("/alterar-senha");
        }
      } else {
        await this.carregarPlano();
        document.title = this.plano.nome;
      }
    }
  }
};
</script>
